import { Typography } from "@mui/material";
import { displayEmptyOrDashConditionally } from "src/utils/genericFunctions";

const ItemWithoutLink = ({
  value,
  consolidatedColumnFlag = false
}: {
  value: string;
  consolidatedColumnFlag?: boolean;
}) => {
  return (
    <Typography variant="subtitle2" color="grey.900" fontWeight={"normal"}>
      {displayEmptyOrDashConditionally(value, consolidatedColumnFlag)}
    </Typography>
  );
};

export default ItemWithoutLink;
